import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EllipsisMenuItem } from '@gainsystems/gains-ui-commons';

@Component({
  selector: 'kpi-widget',
  standalone: false,
  templateUrl: './kpi-widget.component.html',
  styleUrl: './kpi-widget.component.scss'
})
export class KpiWidgetComponent {
  @Input() widgetTitle = '';
  @Input() value: number | string = '--';
  @Input() unit = '';
  @Input() widthClass = 'extra-chart-small';
  @Input() menuItems: EllipsisMenuItem[] = [];
  @Input() widgetId = '';
  @Output() changeEvent = new EventEmitter<string>();

  handleMenuAction(action: string): void {
    // Emit the action to the parent component
    this.changeEvent.emit(action);
  }
}
